import { has } from 'lodash';
import isCalledWithDevtools from '@/utils/isCalledWithDevtools';
import config from './config';

/**
 * Plugin to provide state properties lazy loading.
 *
 * @param  {object} store Vuex store.
 * @returns {void}
 */
export default store => {
    const newState = { ...store.state };
    const dispatchedActions = [];
    const storedValues = {};
    let loaded = false;

    for (const key in config) {
        const action = config[key];

        if (! has(store.state, key) || ! has(store._actions, action)) {
            continue;
        }

        delete newState[key];

        const property = Object.getOwnPropertyDescriptor(store.state, key);
        storedValues[key] = property.get.call();

        Object.defineProperty(newState, key, {
            configurable: true,
            enumerable: true,

            /**
             * Getter method
             *
             * @returns {*} Property value.
             */
            get() {
                if (
                    true === loaded &&
                    ! dispatchedActions.includes(action) &&
                    ! isCalledWithDevtools()
                ) {
                    dispatchedActions.push(action);
                    store.dispatch(action);
                }

                return storedValues[key];
            },

            /**
             * Setter method
             *
             * @param {*} value Value.
             */
            set(value) {
                storedValues[key] = value;
            },
        });
    }

    store.replaceState(newState);

    loaded = true;
};
